"use client";

import { useRouter } from "next/navigation";
import type { PublisherGameFollowers } from "../types";
import type { PublisherGameFollowersSort } from "../api/getPublisherGameFollowers";
import { DataTable, EmptyState } from "@/components/shared";
import { publisherGameFollowersColumns } from "../config";
import { PublisherGameFollowersCards } from "./PublisherGameFollowersCards";
import {
  parseSortParts,
  toggleSortDirection,
  createSortForColumn,
} from "../utils/publisherGameFollowersSort";

interface PublisherGameFollowersListProps {
  games: PublisherGameFollowers[];
  sortBy: PublisherGameFollowersSort;
  onSortChange: (sort: PublisherGameFollowersSort) => void;
}

export function PublisherGameFollowersList({
  games,
  sortBy,
  onSortChange,
}: PublisherGameFollowersListProps) {
  const router = useRouter();

  const handleSortChange = (sortKey: string) => {
    const { column: currentColumn } = parseSortParts(sortBy);

    if (sortKey === currentColumn) {
      onSortChange(toggleSortDirection(sortBy));
    } else {
      onSortChange(createSortForColumn(sortKey as typeof currentColumn));
    }
  };

  if (games.length === 0) {
    return <EmptyState message="No games with followers found." />;
  }

  const { column: currentSortKey, direction: currentSortOrder } =
    parseSortParts(sortBy);

  return (
    <div className="bg-[#16202d] rounded-lg border border-[#2a475e] overflow-hidden">
      <DataTable
        data={games}
        columns={publisherGameFollowersColumns}
        getRowHref={(item) => `/app/${item.appid}`}
        getRowAriaLabel={(item) => item.name}
        getRowKey={(item) => item.appid}
        currentSortKey={currentSortKey}
        sortOrder={currentSortOrder}
        onSortChange={handleSortChange}
      />
      <PublisherGameFollowersCards
        games={games}
        onCardClick={(appid) => router.push(`/app/${appid}`)}
      />
    </div>
  );
}

